

export const section_color = (section) => {
  return `var(--color-menu-${section})`
}
